export default __webpack_public_path__ + "static/johnlee-6270fc70e89f5e6e0dce8ff84ab2ba84.png";